import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import SkeletonSmallPortraitItemArticle from '../../../../topics/Article/components/ItemArticle/views_default/SmallPortraitItemArticle/skeleton'

const Wrapper = styled.div`
  display: flex;
  margin: ${(props) => props.margin} @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    flex-direction: column;
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    flex-direction: column;
  }
  @media (max-width: 450px) {
    margin-right: 0;
    margin-left: 0;
  }
`

const WrapperSkeletonSmallPortraitItemArticle = styled.div`
  flex: 1;
  margin-bottom: ${(props) => props.theme.sizes.gapVertical};
  margin-right: ${(props) => props.theme.sizes.gapCol};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    margin-bottom: ${(props) => props.theme.tablet.sizes.gapVertical};
    margin-right: 0;
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-bottom: ${(props) => props.theme.mobile.sizes.gapVertical};
    margin-right: 0;
  }
`

const WrapperSkeletonSmallPortraitItemArticleLast = styled.div`
  flex: 1;
`

const StyledSkeletonSmallPortraitItemArticle = styled(SkeletonSmallPortraitItemArticle)`
  margin-bottom: ${(props) => props.theme.sizes.gapVerticalHalf};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    margin-bottom: ${(props) => props.theme.tablet.sizes.gapVerticalHalf};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-bottom: ${(props) => props.theme.mobile.sizes.gapVerticalHalf};
  }
`

const SkeletonBlockThreeArticle = ({ margin, ...props }) => {
  return (
    <Wrapper margin={margin} {...props}>
      <WrapperSkeletonSmallPortraitItemArticle>
        <StyledSkeletonSmallPortraitItemArticle />
      </WrapperSkeletonSmallPortraitItemArticle>
      <WrapperSkeletonSmallPortraitItemArticle>
        <StyledSkeletonSmallPortraitItemArticle />
      </WrapperSkeletonSmallPortraitItemArticle>
      <WrapperSkeletonSmallPortraitItemArticleLast>
        <StyledSkeletonSmallPortraitItemArticle />
      </WrapperSkeletonSmallPortraitItemArticleLast>
    </Wrapper>
  )
}

SkeletonBlockThreeArticle.propTypes = {
  margin: PropTypes.string,
}

SkeletonBlockThreeArticle.defaultProps = {
  margin: '0',
}

export default SkeletonBlockThreeArticle
